import { lighten } from "polished";
// import colors, { darkColors } from "../../style/colors";
const solfaColors: { [prop: string]: string } = {};

// export default { ...colors, ...darkColors };
const colorsChoir = {
    grey9: "#999",
    grey7: "#777",
    grey3: "#333",
    grey5: "#555",
    greyE: "#EEE",
    greyD: "#DDD",
    greyA: "#aaa",
    score: "#777",
    cardBackground: "white",
    whiteOnActive: "white",
    snowOnActive: "#F6F4F4",

    mainBoost: "#00968b",
    // active: "#00AAA4",
    // boost: "#00968b",
    // dark: "#005552",
    // light: "#edf6f5",
    // pale: "#a3d3ce",

    active: "#CD822E",
    choirActive: "#CD822E",
    boost: "#cd7a16",
    dark: "#7e4505",
    light: "#FAF2E4",
    pale: "#E8BF7A",

    // active: "#5e61ba",
    // boost: "#524b9a",
    // dark: "#2d215e",
    // light: "#ededf7",
    // wrong: "#dd161d",
    // pale: "#cacae7",

    wrong: "#dd161d",

    disabled: "#CCCCCC",
    info: "#f7c30c",
    snow: "#FBF9F9",
    white: "#FFFFFF",
    black: "black",
    facebook: "#4267b2",
    google: "#DB4437",

    correct: "#4bac09",
    incorrect: "#dd161d",

    play: "#7d44a5",
    playLight: lighten(0.35, "#7d44a5"),
    check: "#63c6bd",
    blackShadow1: "rgba(0, 0, 0, 0.1)",
    blackShadow2: "rgba(0, 0, 0, 0.2)",
    blackShadow3: "rgba(0, 0, 0, 0.3)",
    blackShadow35: "rgba(0, 0, 0, 0.35)",
    blackShadow4: "rgba(0, 0, 0, 0.4)",
    blackShadow5: "rgba(0, 0, 0, 0.5)",
    blackShadow7: "rgba(0, 0, 0, 0.7)",
    youtube: "#af1117",

    christmasBlue: "#69c7c7",
    christmasLightBlue: "#98FDFC",
    record: "#ff3664",
    solfa: solfaColors,
    memoryActive: "#573da8",
    easterBrown: "#443107",
};

export default { ...colorsChoir };
